/** Valores legados/alternativos retornados pela API → enum usado na UI. */
const FROM_API = {
    IN_CREATION: 'CREATION',
    AWAITING_CONFIRMATION: 'CONFIRMATION',
};

/** Valores da UI → enum esperado pela API (spec DeliveryStateEnum). */
const TO_API = {
    CREATION: 'IN_CREATION',
    CONFIRMATION: 'AWAITING_CONFIRMATION',
};

export function normalizeDeliveryStateFromApi(value) {
    if (!value) return '';
    const key = String(value).trim();
    return FROM_API[key] || key;
}

export function toApiDeliveryState(value) {
    if (!value) return null;
    const key = String(value).trim();
    return TO_API[key] || key;
}

/** Converte um ou vários estados da UI para os valores esperados pela API. */
export function toApiDeliveryStates(values) {
    if (values == null) return [];
    const list = Array.isArray(values) ? values : [values];
    return list
        .map((value) => toApiDeliveryState(value))
        .filter(Boolean);
}
